import React, {useState} from 'react'
import _ from 'lodash'
import {Button, ButtonGroup, Input} from 'reactstrap'
import {useSelectedVariantContext} from '../../../context/SelectedVariantContext'
import DesignLibraryModal from './image-library/DesignLibraryModal'
import {
    actionUpdateBgImage,
    actionUpdateBgImageType,
    actionUpdateLoadingBackground
} from '../../../context/SelectedVariantContext/action'
import {ReactComponent as PlusIcon} from '../../../../../assets/icons/plus.svg'
import {ReactComponent as WarningIcon} from '../../../../../assets/icons/warning_amber.svg'
import {getInfomationBackground} from '../../../../../helpers/createProductCombine'
import useGTM, {buildProductPayload, getGTMAttributes} from '../../../../../hooks/useGTM'

const UploadBackgroundImage = () => {
    const {
        state: {listBackgroundImages, currentBgImage, currentBgImageType, product, selectedAttribute, pickerVariants = []},
        dispatch
    } = useSelectedVariantContext()
    const {pushEvent} = useGTM()
    const mockupInfos = _.get(selectedAttribute, 'mockup.meta.mockup_infos', [])
    const mockupBackground = _.get(mockupInfos, '[0].parts[0].image_path', '')
    const [wPreview, setWPreview] = useState(200)
    const [hPreview, setHPreview] = useState(200)
    const options = [
        { value: 'original', label: 'Original' },
        { value: 'fit', label: 'Fit and center' },
        { value: 'fill', label: 'Scale to Fill' },
    ]
    const [isOpenImageDesign, setIsOpenImageDesign] = useState(false)

    const _toggle = () => {
        setIsOpenImageDesign((prev) => !prev)
    }

    const onChangeBackgroundType = (value) => {
        const info = getInfomationBackground(value, currentBgImage)
        const {width, height, x, y} = info
        const backgroundImage = {
            ...currentBgImage,
            width,
            height,
            x,
            y,
        }
        dispatch(actionUpdateBgImage(backgroundImage))
        dispatch(actionUpdateBgImageType(value))
    }

    const onSelectBackgroundImage = (image = null) => {
        if (currentBgImage.key === undefined && !image) return
        if (!!image) {
            const info = getInfomationBackground(currentBgImageType, image)
            const {width, height, x, y} = info
            const newBackgroundImage = {
                ...currentBgImage,
                ...image,
                width,
                height,
                x,
                y,
            }
            if (currentBgImage.key !== image.key) dispatch(actionUpdateLoadingBackground(true))
            dispatch(actionUpdateBgImage(newBackgroundImage))
        } else {
            dispatch(actionUpdateLoadingBackground(true))
            dispatch(actionUpdateBgImage({}))
        }
    }

    // const getInfoPreviewArtworkSlider = () => {
    //     let w = 0
    //     let h = 0
    //     if (document.querySelector('.PreviewArtworkContainer')) {
    //         w = document.querySelector('.PreviewArtworkContainer').offsetWidth
    //         h = document.querySelector('.PreviewArtworkContainer').offsetHeight
    //     }
    //     setWPreview(w)
    //     setHPreview(h)
    // }

    // useEffect(() => {
    //     getInfoPreviewArtworkSlider()
    //     window.addEventListener('resize', getInfoPreviewArtworkSlider)
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [])

    // useEffect(async () => {
    //     //getInfoPreviewArtworkSlider()
    //     //window.addEventListener('resize', getInfoPreviewArtworkSlider)
    // }, [])

    return (
        <div className="UploadBackgroundImage">
            <h4 className="TitleVariantView">Backgrounds</h4>
            {(currentBgImage && (currentBgImage?.naturalHeight < 2000 && currentBgImage?.naturalWidth < 2000)) && (
                <p className="alert-warning"><WarningIcon /> Images with a resolution lower than 2000 x 2000 pixels may
                    appear blurry, which could also impact the ranking of your listing</p>
            )}
            <div className='listBackgroundImages'>
                <div id="upload_mockup_background" className='itemUploadBackgroundImage selectImage flex-column'
                     onClick={_toggle}>
                    <div className="mb-1"><PlusIcon /></div>
                    Upload
                </div>
                <div
                    className={currentBgImage.key === undefined ? 'itemUploadBackgroundImage active' : 'itemUploadBackgroundImage'}
                    onClick={() => onSelectBackgroundImage()}
                    {...getGTMAttributes('select_mockup', {product: buildProductPayload(product, pickerVariants)})}
                    >
                    <img src={mockupBackground} alt="Mockup background" />
                    <div className="RadioWrapper">
                        <Input
                            type="radio"
                            className="custom-control-input"
                            id="default"
                            checked={currentBgImage.key === undefined}
                            // onChange={handleSelectAllVariant}
                        />
                        <label></label>
                    </div>
                </div>
                {listBackgroundImages.length > 0 && listBackgroundImages.map((item) => {
                    return <div
                        className={currentBgImage.key === item.key ? 'itemUploadBackgroundImage active' : 'itemUploadBackgroundImage'}
                        onClick={() => onSelectBackgroundImage(item)}
                        {...getGTMAttributes('select_mockup', {product: buildProductPayload(product, pickerVariants)})}
                    >
                        <img src={item?.file} alt='' />
                        <div className='RadioWrapper'>
                            <Input
                                type='radio'
                                className='custom-control-input'
                                id={item.key}
                                checked={currentBgImage.key === item.key}
                                // onChange={handleSelectAllVariant}
                            />
                            <label></label>
                        </div>
                    </div>
                })}
            </div>
            {currentBgImage.file !== undefined && (
                <div className='GroupButtonType d-flex'>
                    <ButtonGroup>
                        {options.map(item => {
                            return <Button id='effect_mockup_background'
                                           className={`${currentBgImageType === item.value ? 'active' : ''}`} outline
                                           onClick={() => onChangeBackgroundType(item.value)}
                                           {...getGTMAttributes('select_mockup', {product: buildProductPayload(product, pickerVariants)})}
                                           >
                                {item.label}
                            </Button>
                        })}
                    </ButtonGroup>
                </div>
            )}
            <p className="Recommended">
                Recommended resolution 2000 x 2000 px (72 DPI). Supported PNG, JPG, SVG files. Maximum file
                storage 50MB
            </p>
            {isOpenImageDesign && <DesignLibraryModal isOpen={isOpenImageDesign} toggle={_toggle} wPreview={wPreview}
                                                      hPreview={hPreview} />}
        </div>
    )
}

export default UploadBackgroundImage

